import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
export default function Layout() {
    const { pathname } = useLocation();
    // ページ遷移時にスクロールを先頭に戻す
    useEffect(()=>{
        window.scrollTo(0, 0);
    }, [
        pathname
    ]);
    return /*#__PURE__*/ _jsx(Outlet, {});
}
